import React from "react";
import "../style/MainContainer.css";
import { Container } from "reactstrap";

export default function MainContainer(props) {
  return (
    <Container className="p-3 main-container" id="container">
      {props.children}
    </Container>
  );
}
